import ProductionPlannerPage from '../components/production/ProductionPlannerPage';

export default function AdminProduction() {
  return (
    <ProductionPlannerPage
      title="Production Planner"
      subtitle="Plan one or many dishes together — pick recipes, enter quantities, and get a single aggregated raw-ingredient picklist. Toggle 'Show all recipes' to see recipes not yet assigned to the outlet."
      testIdPrefix="admin-production"
    />
  );
}
